import { Outlet } from 'react-router-dom';

import { MainSection } from '@app/shared/ui/atoms/Layout';

export function GuestLayout() {
  return (
    <MainSection className="px-5">
      <Outlet />
    </MainSection>
  );
}
